"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var Span = _styledComponents.default.span.withConfig({
  displayName: "Available__Span",
  componentId: "sc-1bv8net-0"
})(["position:relative;top:-2px;> svg{width:10px;height:10px;}"]);

var Available = function Available(_ref) {
  var isAgentAvailable = _ref.isAgentAvailable;
  return /*#__PURE__*/_react.default.createElement(Span, null, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    color: isAgentAvailable ? "#7ccc13" : "#f5b723",
    icon: _freeSolidSvgIcons.faCircle
  }));
};

Available.propTypes = {
  isAgentAvailable: _propTypes.default.bool
};
var _default = Available;
exports.default = _default;